import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: { p: 1 } as SxProps<Theme>,
};
